import React, { useState , useEffect} from 'react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import Header from './header';
import Footer from './footer';
import './style/users.css';
// import { getDefaultNormalizer } from '@testing-library/dom';
// import { MDBDataTable } from 'mdbreact';

function ManageUsers() {

  let history = useHistory()

  const [email, setEmail] = useState("");
  const [msg, setMessage] = useState("");
  const [msg1, set1Message] = useState("");
  const [status, setStatus] = useState(false);
  const [semail, setSEmail] = useState("");

  if(false)
  {
    //did this to remove warnings
      setEmail(email);
      setStatus(status);
  }

  const onChangeSEmail = (e) => setSEmail(e.target.value);

    const [list, setList] = useState([]);
    useEffect(()=> {
      axios.get('https://akshatngupta-bike-rental.herokuapp.com/user')
      .then(response => {
        // if(response.data[0]==0)
        // setMessage("NO USERS PRESENT");
        //  console.log(response.status);
        // console.log(response.data)
        // if(response.status==4)
        // {
        //   setMessage('NO USER EXISTS! PLEASE CHECK AFTER SOMETIME') 
        //   setStatus(false)
        // }
        // if(status==false)
        // break;
        if(semail==="")
          setList(response.data);
        
      })
      .catch((error) => {
        if(error.response.status===404)
          setList([]);
        console.log(error);
        set1Message('NO USER EXISTS! PLEASE CHECK AFTER SOMETIME') 
      })
    })
    
    // const onChangeSearch = (e) =>{
    //   setSearch(false)
    // }

    const handleSubmit = (evt) => {

      evt.preventDefault();
      console.log(`EMAIL: ${semail}`);
      axios.get('https://akshatngupta-bike-rental.herokuapp.com/user/search/' + semail)
        .then(res => {
          console.log(res.data)
          setList(res.data)
          setStatus(true)
        })
        .catch(err => {
          console.log(err)
          setMessage('INVALID EMAIL ID')
        })
        // setList([])
      // setEmail('')
      // arya7@gmail.com
    }

    const handleClick = event => {
      event.preventDefault();
      let values = event.target.dataset.mssg.split("_")
      if(values[1] === "Update"){
        sessionStorage.setItem('email',values[0])
        history.push(`/updateprofile/${values[0]}`
        )
        setMessage('SUCCESSFULLY UPDATED')
      }
      else{
        let email = values[0]
        axios.delete('https://akshatngupta-bike-rental.herokuapp.com/user/remove/' + email)
        .then(res => {
          console.log(res.data)
          axios.delete('https://akshatngupta-bike-rental.herokuapp.com/booking/removeall/' + email)
          .then(res => {
          console.log(res.data)
          setMessage('SUCCESSFULLY DELETED')
          })
          .catch(err => {
          console.log(err)
          setMessage('INVALID USER ID')
          })
          setMessage('SUCCESSFULLY DELETED')
        })
        .catch(err => {
          console.log(err)
          setMessage('INVALID USER ID')
        })
      }
      setEmail('')
    }
    
    return (
      <div>
      <Header />
      <div>
        <form className="shift">
        <table className="table table-adminUser">
          <thead className="thead-dark"> 
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Address</th>
              {/* <th>Password</th> */}
              <th>Action</th>
              <th id="search"><form onSubmit={handleSubmit} >
        <input type="email"  value={semail} placeholder="EMAIL ID" onChange={onChangeSEmail} required />
        <input type="submit" value="SEARCH USER" onChange={onChangeSEmail} className="btn btn-danger" />
      </form></th>
            </tr>
          </thead>
          {list.map((currentrow,idx) => {
            return (<tr key={idx}>
              <td>{currentrow.name}</td>
              <td>{currentrow.email}</td>
              <td>{currentrow.mobile}</td>
              <td>{currentrow.address}</td>
              {/* <td>{currentrow.pass}</td> */}
              {/* <td>{currentrow.}</td> */}
              <td id="diffrence">
                <button type="button"  data-mssg={`${currentrow.email}_Update`}  onClick={handleClick} class="btn btn-primary btn-others">Update</button>
                <button type="button" data-mssg={`${currentrow.email}_Delete`} onClick={handleClick} class="btn btn-danger btn-others">Delete</button>
              </td>
            </tr>
            )})}
        </table>
        </form>
      </div> 
      <div>
      <b style={{ color: "red" }}>{msg}</b>
      </div>
      <div>
      <b style={{ color: "red" }}>{msg1}</b>
      </div>
      {/* <div>
      <b style={{ color: "red" }}>{msg1}</b>
      </div> */}
      {/* <MDBDataTable striped bordered small data={response.data} /> */}
      <Footer />
      </div>
)}

export default ManageUsers
